module.exports = __webpack_public_path__ + "static/media/WhiteFast.2cc5ae0e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/WhiteFast.wav
// module id = 63
// module chunks = 0